<span class="badge pedido-drp-lucro-liquido-badge"
    [ngClass]="{'pedido-drp-lucro-liquido-badge-abaixo': percLucroLiquidoAbaixo, 'pedido-drp-lucro-liquido-badge-acima': !percLucroLiquidoAbaixo}"
    [ngStyle]="{'fontSize': fontSize, 'padding': padding}"
    title="Demonstração do Resultado do Pedido">

    <ng-template [ngIf]="isLoading">
        <i class='fas fa-spinner fa-pulse'></i>
    </ng-template>

    <ng-template [ngIf]="!isLoading && percLucroLiquido != null && percLucroLiquido !== undefined">
        <span *ngIf="isShowLabel">
            D.R.P.
        </span>
        {{percLucroLiquido | decimalFormat: 1:2:2}}%
    </ng-template>    
</span>